/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AutocompleteAddressResponse as ModelsCustomerAutocompleteAddressResponse } from '../models/Models/Customer/autocomplete-address-response';
import { v4AddressesGet$Json } from '../fn/addresses/v-4-addresses-get-json';
import { V4AddressesGet$Json$Params } from '../fn/addresses/v-4-addresses-get-json';
import { v4AddressesGet$Plain } from '../fn/addresses/v-4-addresses-get-plain';
import { V4AddressesGet$Plain$Params } from '../fn/addresses/v-4-addresses-get-plain';
import { v4AddressesGet$Xml } from '../fn/addresses/v-4-addresses-get-xml';
import { V4AddressesGet$Xml$Params } from '../fn/addresses/v-4-addresses-get-xml';

@Injectable({ providedIn: 'root' })
export class AddressesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v4AddressesGet()` */
  static readonly V4AddressesGetPath = '/v4/addresses';

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4AddressesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4AddressesGet$Plain$Response(params?: V4AddressesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerAutocompleteAddressResponse>> {
    return v4AddressesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4AddressesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4AddressesGet$Plain(params?: V4AddressesGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerAutocompleteAddressResponse> {
    return this.v4AddressesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerAutocompleteAddressResponse>): ModelsCustomerAutocompleteAddressResponse => r.body)
    );
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4AddressesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4AddressesGet$Json$Response(params?: V4AddressesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerAutocompleteAddressResponse>> {
    return v4AddressesGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4AddressesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4AddressesGet$Json(params?: V4AddressesGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerAutocompleteAddressResponse> {
    return this.v4AddressesGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerAutocompleteAddressResponse>): ModelsCustomerAutocompleteAddressResponse => r.body)
    );
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4AddressesGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4AddressesGet$Xml$Response(params?: V4AddressesGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerAutocompleteAddressResponse>> {
    return v4AddressesGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4AddressesGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4AddressesGet$Xml(params?: V4AddressesGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerAutocompleteAddressResponse> {
    return this.v4AddressesGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerAutocompleteAddressResponse>): ModelsCustomerAutocompleteAddressResponse => r.body)
    );
  }

}
